import React from 'react';
import { cn } from '../../lib/utils';

interface StackProps {
  children: React.ReactNode;
  className?: string;
  gap?: 0 | 1 | 2 | 3 | 4 | 6 | 8 | 10;
  wrap?: boolean;
}

export function VerticalStack({ children, className, gap = 4 }: StackProps) {
  const gapClass = {
    0: 'space-y-0',
    1: 'space-y-1',
    2: 'space-y-2',
    3: 'space-y-3',
    4: 'space-y-4',
    6: 'space-y-6',
    8: 'space-y-8',
    10: 'space-y-10',
  }[gap];

  return <div className={cn(gapClass, className)}>{children}</div>;
}

export function HorizontalStack({ children, className, gap = 4, wrap = false }: StackProps) {
  const gapClass = {
    0: 'gap-0',
    1: 'gap-1',
    2: 'gap-2',
    3: 'gap-3',
    4: 'gap-4',
    6: 'gap-6',
    8: 'gap-8',
    10: 'gap-10',
  }[gap];

  return <div className={cn('flex items-center', wrap && 'flex-wrap', gapClass, className)}>{children}</div>;
}
